import { isObject } from 'lodash';

export type StoryRenderOptions = {
    withTitle: boolean;
    muted: boolean;
    canUnmute: boolean;
};

const DEFAULT_STORY_RENDER_OPTIONS: StoryRenderOptions = {
    withTitle: true,
    muted: true,
    canUnmute: true,
};

export const sanitizeStoryConfig = (story: unknown): StoryRenderOptions => {
    if (!isObject(story)) return DEFAULT_STORY_RENDER_OPTIONS;
    const withTitle =
        'withTitle' in story && typeof story.withTitle === 'boolean'
            ? story.withTitle
            : DEFAULT_STORY_RENDER_OPTIONS.withTitle;
    const muted =
        'muted' in story && typeof story.muted === 'boolean'
            ? story.muted
            : DEFAULT_STORY_RENDER_OPTIONS.muted;
    const canUnmute =
        'canUnmute' in story && typeof story.canUnmute === 'boolean'
            ? story.canUnmute
            : DEFAULT_STORY_RENDER_OPTIONS.canUnmute;
    return {
        withTitle,
        muted,
        canUnmute,
    };
};
